// CompanyProfile.tsx
import CompanyDetails from "./companyDetails";
import BuilderDetails from "./builderDetails";
import { useState } from "react";
// import ProfileDetailsForm from "./ProfileDetailsForm";

const CompanyProfile = () => {
  // const [isProfileDetailsDialog,setIsProfileDetailsDialog]
  const [isCompanyDetailHidden, setIsCompanyDetailHidden] = useState(false);

  return (
    <div className="max-h-screen flex flex-col overflow-y-hidden">
      <div className="bg-gray-50">
        <CompanyDetails
          isCompanyDetailHidden={isCompanyDetailHidden}
          setIsCompanyDetailHidden={setIsCompanyDetailHidden}
        />
      </div>
      <div className="flex-1">
        <BuilderDetails isCompanyDetailHidden={isCompanyDetailHidden} />
      </div>
    </div>
  );
};

export default CompanyProfile;
